import type { WeatherConfig, WeatherSystemConfig } from '@/common/types/weather.types'

export const weatherConfig: Record<string, WeatherConfig> = {
  '0': {
    id: 0,
  },
  '1': {
    id: 1,
    lastDays: 2,
    vigour: 1,
    item_1101061: -4,
  },
  '2': {
    id: 2,
    lastDays: 2,
    build_2: 2,
    spirit: -1,
  },
  '3': {
    id: 3,
    lastDays: 3,
    speed: -0.1,
    temperature: -2,
    item_1103041: 4,
  },
  '4': {
    id: 4,
    lastDays: 2,
    gun_precise: -0.15,
    monster_speed: -1,
  },
} as const

export const weatherSystemConfig: WeatherSystemConfig = {
  '0': [
    { weatherId: '0', weight: 5 },
    { weatherId: '1', weight: 1 },
    { weatherId: '2', weight: 1 },
    { weatherId: '3', weight: 0 },
    { weatherId: '4', weight: 0 },
  ],
  '1': [
    { weatherId: '0', weight: 5 },
    { weatherId: '1', weight: 1 },
    { weatherId: '2', weight: 0 },
    { weatherId: '3', weight: 2 },
    { weatherId: '4', weight: 0 },
  ],
  '2': [
    { weatherId: '0', weight: 5 },
    { weatherId: '1', weight: 2 },
    { weatherId: '2', weight: 1 },
    { weatherId: '3', weight: 0 },
    { weatherId: '4', weight: 1 },
  ],
  '3': [
    { weatherId: '0', weight: 1 },
    { weatherId: '1', weight: 3 },
    { weatherId: '2', weight: 3 },
    { weatherId: '3', weight: 0 },
    { weatherId: '4', weight: 3 },
  ],
} as const


